<template>
  <div>
    <div class="d-flex">
      <b-form-input
        placeholder=""
        :value="value ? value.label : ''"
        trim
        readonly
      ></b-form-input>
      <b-button @click="showListModal = true" variant="primary" class="ml-2">
        <i
          class="fa fa-ellipsis-v"
          style="font-size: 19px; padding: 1.4px 2.4px 2.6px 2.4px;"
        ></i>
      </b-button>
    </div>
    <b-modal
      centered
      ref="form-modal"
      title="Taxonomy"
      header-bg-variant="primary"
      header-text-variant="white"
      header-class="bg-purple"
      no-close-on-backdrop
      size="md-lg"
      v-model="showListModal"
    >
      <template v-slot:modal-footer="{ cancel }">
        <b-button variant="secondary" @click="cancel()">
          Close
        </b-button>
      </template>
      <div>
        <b-row>
          <b-col cols="6">
            <b-form-group label="Specialty">
              <b-form-select
                placeholder=""
                v-model="taxonomiesFilter.specialty"
                :options="taxonomySpecialties"
              ></b-form-select>
            </b-form-group>
          </b-col>
        </b-row>
        <grid
          class=""
          ref="grid"
          :groupFeature="false"
          :columns="taxonomyColumns"
          :autoHeight="true"
          :data="taxonomyItems"
          :columnLines="false"
          :searchFeature="true"
          :stripeFeature="false"
        ></grid>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Grid from "../../third_party/grid/Grid";
import taxonomyServer from "../../server/taxonomy";

export default {
  name: "TaxonomyPicker",
  components: { Grid },
  props: ["value"],
  data() {
    return {
      taxonomiesFilter: {
        specialty: null
      },
      taxonomies: [],
      total: 0,
      paginator: {
        page: 0,
        perPage: 1000000
      },
      showListModal: false
    };
  },
  mounted() {
    this.getTaxonomies();
    this.fetchTaxonomySpecialties();
  },
  methods: {
    ...mapActions("client", ["fetchTaxonomySpecialties"]),
    async getTaxonomies() {
      const result = await taxonomyServer.query({
        taxonomySpecialtyId: this.taxonomiesFilter.specialty
          ? this.taxonomiesFilter.specialty
          : null,
        page: this.paginator.page,
        pageSize: this.paginator.perPage
      });
      this.taxonomies = result.records;
      this.total = result.count;
    }
  },
  computed: {
    ...mapState("client", {
      taxonomySpecialties: state => [
        {
          value: null,
          text: "All"
        },
        ...state.taxonomySpecialties.map(taxonomySpecialty => ({
          value: taxonomySpecialty.id,
          text: taxonomySpecialty.name
        }))
      ]
    }),
    taxonomyItems() {
      return this.taxonomies
        .map(item => ({
          ...item
        }))
        .sort((a, b) =>
          a.name.toLowerCase().localeCompare(b.name.toLowerCase())
        );
    },
    taxonomyColumns() {
      let columns = [
        {
          text: "Code",
          field: "code",
          flex: 1,
          editor: false,
          sortable() {
            return self.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Name",
          field: "name",
          flex: 1,
          editor: false,
          sortable() {
            return self.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Type",
          field: "taxonomyType.name",
          flex: 1,
          editor: false,
          type: "template",
          template: data =>
            data.record.data.taxonomyType
              ? data.record.data.taxonomyType.name
              : "",
          sortable() {
            return self.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "Specialty",
          field: "taxonomySpecialty.name",
          flex: 1,
          editor: false,
          type: "template",
          template: data =>
            data.record.data.taxonomySpecialty
              ? data.record.data.taxonomySpecialty.name
              : "",
          sortable() {
            return self.orderByDescending ? -1 : 1;
          }
        },
        {
          text: "",
          type: "action",
          cellCls: "pointer-cell",
          field: "action",
          align: "right",
          width: 80,
          actions: [
            {
              tooltip: "Select",
              renderer: () =>
                `<span class="b-action-item action-link-text select-taxonomy text-primary">Select</span>`,
              onClick: async ({ record }) => {
                this.$emit("input", {
                  value: record.id,
                  label: record.data.code
                });
                this.showListModal = false;
              }
            }
          ]
        }
      ];
      return columns;
    }
  },
  watch: {
    "taxonomiesFilter.specialty": function() {
      this.paginator = {
        page: 0,
        perPage: 1000000
      };
      this.getTaxonomies();
    }
  }
};
</script>

<style></style>
